export default __webpack_public_path__ + "img/img3.825aa52e.jpg";